<template>
    <div class="editor">
        <!-- 顶部栏 -->
        <top-header :sceneData="sceneData"></top-header>

        <div class="content">
            <!-- 主区域 -->
            <div class="left">
                <tool 
                    v-if="readyScene"
                    ref="tool"
                    :measureData="measureData"
                    :flyData="flyData"
                    @measureChange="e => measureData = e"
                ></tool>
                <div class="container" ref="container"></div>
            </div>
            <!-- 右侧菜单 -->
            <div class="right">
                <right-menu ref="menu" :sceneData="sceneData" @toggleScreen="toggleScreen"></right-menu>
            </div>
            <!-- 底部Logo -->
            <div class="logo">
                <img src="@/assets/img/logo3.png" />
                <span>老子云技术支持</span>
            </div>
        </div>
    </div>
</template>

<script>
import initMixin from '@/mixins/earthInit'
import TopHeader from './Header.vue'
import Tool from './Tool.vue'
import RightMenu from './Menu.vue'

export default {

    components: {
        TopHeader,
        Tool,
        RightMenu
    },

    mixins: [
        initMixin
    ],

    mounted(){
        this.init()
    },

    methods: {
        toggleScreen( status ){
            this.$refs.container.style.width = status ? '100%' : '100vw'
            this.viewer.resize()
        }
    }
}
</script>

<style lang="scss" scoped> 
@import './style.scss';
.editor{
    width: 100vw; height: 100vh; overflow: hidden; position: relative;
    .logo{
        position: fixed; bottom: 50px; width: 300px; height: 50px; line-height: 50px;  left: calc(50% - 350px); text-align: center;
        img{ width: 49px; position: relative; top: 25px; margin: 10px; opacity: 0.5; }
        span{ color: #FFF; opacity: 0.3; font-size: 20px; letter-spacing: 1px; }
    }
}
</style>
<style>
.cesium-widget-credits{ display: none; }
</style>

